<template>
    <div id="sport">
        <div class="main_photo" style="background-image: url(/imgs/portfolio/open/Sport_open.jpg)">
                <div class="port_open">Sport</div>
        </div>
        <SportMosaic></SportMosaic>
    </div>
</template>

<script>
import SportMosaic from '@/components/portfolio/SportMosaic.vue';
export default {
    name: 'MOASport',
    metaInfo() {
        return {
            title: 'MOA - Sport',
            meta: [
                {name: 'title', content:'Matteo Ortili Art - Sport'},
                {name: 'description', content: 'Matteo Ortili\'s Sport photos'},
                {property: 'og:title', content: "Matteo Ortili Art - Sport"},
                {property: 'og:site_name', content: 'MatteOrtiliArt (MOA)'},
                {property: 'og:type', content: 'website'},
                {property: 'og:url', content: 'https://www.matteortili.com/#/portfolio/sport'},
                {property: 'og:description', content: 'Matteo Ortili\'s Sport photos'},
                {property: 'og:image:secure_url', itemprop: 'image', content: 'https://www.matteortili.com/imgs/portfolio/open/Sport_open.jpg'},
                
            ]
        }
    },
    components: {
        SportMosaic
    }
}
</script>

<style scoped>
.main_photo{
    width: 100%;
    height: 100vh;
    overflow: hidden;
    
    background-position: center center;
    background-size: cover;
}

.port_open{
    width: 100%;
    height: 100%;
    text-align: center;
    padding-top: 370px;
    letter-spacing: 2vw;
    text-transform: uppercase;
    color: white;
}

@media screen and (min-width: 705px) {
    .port_open{
        font-size: 52pt;
    }
  }
 
  @media screen and (max-width: 704px) {
    .port_open{
        font-size: 9vw;
    }
  }
</style>